import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { MANUAL_JOURNAL_ENTRY_API } from "./apiRoutes";
import axiosAuth from "../axiosAuth";

const mutateAddMJEForm = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${MANUAL_JOURNAL_ENTRY_API(data.communityId)}/submit-form`, data);
};

const useAddMJEFormMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddMJEForm,
    ...queryParams,
  });

export default useAddMJEFormMutation;
